<template>
    <div class="rgpd-page">
        <div class="default-home rgpd-page__shell">
            <div class="rgpd-page__header">
                <div>
                    <span class="rgpd-page__eyebrow">Confidentialité</span>
                    <h5 class="title rgpd-page__title">{{ $tl("labels.routes.rgpd") }}</h5>
                    <p class="rgpd-page__subtitle">Pilotez simplement les durées de conservation et l’accès à la politique de données.</p>
                </div>
            </div>
            <LoaderComponent v-if="loading" />
            <template v-else>
                <div class="rgpd-page__card">
                    <div class="rgpd-page__section-head">
                        <strong>{{ $tl("labels.rgpd.timeToKeep") }}</strong>
                    </div>
                    <div class="rgpd-page__form-grid">
                        <div class="rgpd-page__field-copy">
                            {{ $tl("labels.rgpd.clientNewsletter") }}
                        </div>
                        <div>
                            <input type="number" class="form-control" v-model="rgpd.keep_clients_on_newsletter_for" step="1" min="1" max="3" />
                            <ShowErrors class="d-block" :errors="errors" errorKey="keep_clients_on_newsletter_for" />
                        </div>
                        <div class="rgpd-page__field-copy">
                            {{ $tl("labels.rgpd.clientData") }}
                        </div>
                        <div>
                            <input type="number" class="form-control" v-model="rgpd.keep_clients_details_and_history_for" step="1" min="1" max="10" />
                            <ShowErrors class="d-block" :errors="errors" errorKey="keep_clients_details_and_history_for" />
                        </div>
                    </div>
                    <div class="rgpd-page__notice">
                        <small>{{ $t("infos.rgpd.legalTimeToKeep1") }}<br />{{ $t("infos.rgpd.legalTimeToKeep2") }}</small>
                    </div>
                    <button class="btn btn-success btn-circle mt-3" @click="save">
                        {{ $tl("labels.form.actions.save") }}
                    </button>
                </div>

                <div class="rgpd-page__card rgpd-page__document-card">
                    <div>
                        <span class="rgpd-page__eyebrow">Document</span>
                        <strong>{{ $tl("labels.rgpd.pcdp") }}</strong>
                    </div>
                    <a :href="`/default_data_policy`" target="_blank" class="rgpd-page__document-link">
                        {{ $tl("labels.rgpd.pcdp") }}
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../../../components/LoaderComponent";
import ShowErrors from "../../../components/errors/ShowErrors";
import axios from "axios";

export default {
    data() {
        return {
            loading: false,
            errors: null,
            criticalError: false,
            rgpd: {
                keep_clients_on_newsletter_for: undefined,
                keep_clients_details_and_history_for: undefined,
            },
        };
    },
    computed: {
        isOwner() {
            return this.$store.getters["users/role"] === "owner";
        },
    },
    methods: {
        fetchData(loading = true) {
            this.loading = loading;

            this.$store
                .dispatch("users/fetchCurrentUser", { set: true })
                .then((data) => {
                    this.loading = false;
                    _.assign(this.rgpd, data);
                })
                .catch((error) => {
                    this.loading = false;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: this.getErrorMsgFromErrorResponse(error),
                    });
                });
        },
        save() {
            this.loading = true;
            this.errors = null;

            axios
                .post("/api/rgpd", this.rgpd)
                .then((response) => {
                    this.fetchData(false);
                    this.$notify({
                        group: "notification",
                        type: "success",
                        title: response.data.message,
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response && error.response.data.errors) this.errors = error.response.data.errors;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: this.getErrorMsgFromErrorResponse(error),
                    });
                });
        },
    },
    components: {
        LoaderComponent,
        ShowErrors,
    },
    created() {
        if (!this.isOwner) this.$router.push("/");
        else this.fetchData();
    },
};
</script>

<style scoped>
.rgpd-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.rgpd-page__shell {
    max-width: 1080px;
    margin: 0 auto;
}

.rgpd-page__header {
    margin-bottom: 18px;
}

.rgpd-page__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.rgpd-page__title {
    margin: 0;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.rgpd-page__subtitle {
    max-width: 620px;
    margin: 8px 0 0;
    color: #6c7f88;
    line-height: 1.5;
}

.rgpd-page__card {
    margin-bottom: 18px;
    padding: 24px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

.rgpd-page__section-head {
    margin-bottom: 18px;
    color: #173746;
}

.rgpd-page__form-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 220px;
    gap: 14px 20px;
    align-items: center;
}

.rgpd-page__field-copy {
    color: #334e5a;
    font-weight: 600;
}

.rgpd-page__notice {
    margin-top: 18px;
    padding: 14px 16px;
    border-radius: 14px;
    background: rgba(48, 164, 183, 0.08);
    color: #5f737c;
}

.rgpd-page__document-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
}

.rgpd-page__document-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    border: 1px solid rgba(48, 164, 183, 0.2);
    border-radius: 999px;
    color: var(--main-color-light, #30a4b7);
    font-weight: 700;
    background: rgba(48, 164, 183, 0.06);
}

@media (max-width: 767.98px) {
    .rgpd-page {
        padding: 20px 12px 32px;
    }

    .rgpd-page__form-grid {
        grid-template-columns: 1fr;
    }

    .rgpd-page__document-card {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
